import { render, staticRenderFns } from "./CarbonAd.vue?vue&type=template&id=72788fb0"
import script from "./CarbonAd.vue?vue&type=script&lang=js"
export * from "./CarbonAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72788fb0')) {
      api.createRecord('72788fb0', component.options)
    } else {
      api.reload('72788fb0', component.options)
    }
    module.hot.accept("./CarbonAd.vue?vue&type=template&id=72788fb0", function () {
      api.rerender('72788fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/ads/CarbonAd.vue"
export default component.exports